import React, {
  Fragment,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { ActionIcon, Loader, usePrintDispatch } from '@mummssoftware/common-ui';
import { Printer } from '@mummssoftware/icons';
import { Printing } from '@mummssoftware/utils';
import { createPortal } from 'react-dom';
import { Menu, MenuItem } from '@material-ui/core';
import { Orders } from '@mummssoftware/utils/constants';
import { OrdersContext } from '../../context';

type PrintSingleOrderCellProps = {
  order: mumms.Order;
};

export const PrintSingleOrderCell = ({ order }: PrintSingleOrderCellProps) => {
  const { patient, currentUser, keycloak, agency } = useContext(OrdersContext);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const printingService = useMemo(
    () =>
      keycloak && currentUser
        ? new Printing({
            url: window.env.hosts.printingService as string,
            keycloak,
            agency,
            currentUser,
          })
        : null,
    [keycloak, agency, currentUser],
  );

  const getPrintPromise = useCallback(
    (faxInstructions: any, emailInstructions: any) =>
      printingService!.printOrdersAndNotes(
        [order],
        patient!,
        Orders as any,
        faxInstructions,
        emailInstructions,
      ),
    [printingService, order, patient],
  );

  const { print, fax, email } = usePrintDispatch(
    getPrintPromise,
    () => {
      setAnchorEl(null);
      setLoading(true);
    },
    () => setLoading(false),
  );

  const guard = (fn: () => void) => () => {
    if (!keycloak || !patient || !printingService) return;
    fn();
  };

  return (
    <Fragment>
      <ActionIcon
        style={{
          margin: 0,
        }}
        Icon={Printer}
        onClick={(e: any) => setAnchorEl(e?.currentTarget)}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={guard(print)}>Print</MenuItem>
        <MenuItem onClick={guard(fax)}>Fax</MenuItem>
        <MenuItem onClick={guard(email)}>Email</MenuItem>
      </Menu>
      {loading &&
        createPortal(
          <Loader />,
          document.getElementById('portal-container') || document.body,
        )}
    </Fragment>
  );
};
